import React, { memo } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import { IButton, ITypo } from '@/app/_components/common';
import { ROUTERS } from '@/constants';
import { CaseStudy } from '@/types/case-study';
import { getImageUrl } from '@/utils';

const SlideCard = ({ data }: { data: CaseStudy }) => {
	return (
		<div className="mx-3 rounded-3xl bg-white p-3 lg:mx-6 lg:flex lg:gap-6 lg:p-6">
			<div className="relative aspect-[635/467] flex-1 max-w-full  ">
				<Image
					src={getImageUrl(data?.image).imageUrl}
					blurDataURL={getImageUrl(data?.image).imagePlaceholder}
					alt={data.title || 'DLA Da Nang'}
					placeholder="blur"
					fill
					priority
					className="object-cover object-center"
				/>
			</div>

			<div className="col gap-3 w-[477px] max-w-full text-center max-lg:mt-3 lg:text-left">
				<ITypo size={16} weight="semi" as="h3" className="lg:text-24">
					{data.title}
				</ITypo>

				<div className="row justify-center gap-3 lg:justify-start">
					{/* <div className="center bg-blue-ocean size-7 rounded-full p-1 text-white lg:size-[50px]">
						<ITypo size={14} weight="semi" className="lg:text-18">
							{data.result}
						</ITypo>
					</div>

					<ArrowRight className="w-5 lg:w-7" /> */}

						<ITypo size={14} weight="semi" className="text-bittersweet lg:text-18">
						{data.result}
						</ITypo>
				</div>

				<ITypo size={14} as="p" className="lg:text-16">
					{data.description}
				</ITypo>

				<div className="col gap-2">
					<ITypo
						size={14}
						weight="semi"
						as="h4"
						className="lg:text-16"
					>
						{data.teacherName}
					</ITypo>
					<ITypo size={12} as="p" className="text-gray lg:text-14">
						Sinh viên
					</ITypo>
				</div>

				<Link href={ROUTERS.PROUD_DETAIL.replace(':slug', data.slug)}>
					<IButton
						className="mt-3 h-fit min-h-9  sm:min-h-10 w-fit mx-auto lg:mx-0"
						variant={'bordered'}
					>
						<ITypo size={14} className="sm:text-16">
							Xem hành trình
						</ITypo>
					</IButton>
				</Link>
			</div>
		</div>
	);
};

export default memo(SlideCard);
